import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import ContractCheckoutValidator from '../../../common/validation/ContractCheckoutValidator';
import handleSubmitFail from '../SubmitFailHandler';
import './CreditAssessmentStep3Failure.scss';
import Configuration from '../../../common/Configuration.json';

const CreditAssessmentStep3Failure = (props) => {
  const { disableRetry, handleSwitchToOpenTerm, connectionFee, modemPrice } = props;
  return (
    <section>
      <form>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h3 className="half-charcoal">Uh-oh, we didn&apos;t get an all-ok after running that check</h3>
              <p>
                We can&apos;t give you the exact reason, but we can tell you that, either:
              </p>
              <ol className="ca-failure-reasons">
                <li>
                  Your credit assessment result did not meet our requirements.
                </li>
                <li>
                  You have reached the maximum number of attempts in submitting your details.
                </li>
              </ol>
              <p>
                Not to worry as you can choose a No-Pesky-Term contract for Unlimited Broadband instead!
                Simply click the button below to proceed.
                <br />
                Just a heads up - a ${connectionFee} connection fee and ${modemPrice} modem charge will
                apply on a No-Pesky-Term contract.
              </p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="step-3-failure-error-container">
              {disableRetry() &&
              <p>
                Sorry, you&apos;ve retried too many times. You can continue to sign up by switching to no pesky term.
              </p>
              }
              <Button
                id="switch-to-open-term-button"
                type="button"
                className="btn btn-default"
                onClick={handleSwitchToOpenTerm}
              >
                SWITCH TO NO PESKY TERM
              </Button>
            </div>
          </div>
        </div>
      </form>
    </section>
  );
};

const mapStateToProps = () => ({
  connectionFee: Configuration.connectionFee,
  modemPrice: Configuration.modemPrice
});

CreditAssessmentStep3Failure.propTypes = {
  disableRetry: PropTypes.func,
  handleSwitchToOpenTerm: PropTypes.func,
  connectionFee: PropTypes.number,
  modemPrice: PropTypes.number
};

export default connect(mapStateToProps)(reduxForm({
  form: 'checkout', // Form name is same
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,  // unregister fields on unmount
  validate: ContractCheckoutValidator,
  onSubmitFail: err => handleSubmitFail(err)
})(CreditAssessmentStep3Failure));



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CreditAssessmentStep3Failure/CreditAssessmentStep3Failure.js
 **/